<template>
	<div class="bg-[#fefefe] h-full">
		<div class="flex justify-center w-full">
			<BreadCrumb
				v-model="step"
				:crumbs="steps"
			/>
		</div>
		<div class="px-14 flex flex-col gap-4">
			<div>
				<h1 class="text-2xl font-bold color-[#272728]">
					{{ $t('visualizeDispersion') }}
				</h1>
				<p>{{ $t('sePreferirCliqueParaEditar') }}</p>
			</div>
			<div
				v-if="store.state.medicoesHistoricas.length"
				class="block w-full"
			>
				<div class="flex">
					<Dropdown
						v-model="variavelBiometrica"
						class="!w-fit"
						:label="$t('variables')"
						:options="store.getters.dropdownVisualizarDispersao"
					/>
					<div class="flex justify-end gap-4">
						<DropdownCheckboxFk
							v-model="modelFazenda"
							class="w-[400px]"
							:label="$t('farm')"
							:dropdown-options="store.getters.fazendas"
							:ignore-properties="['id', 'Nome']"
						/>
						<DropdownCheckboxFk
							v-model="modelTalhao"
							class="w-[400px]"
							:label="$t('section')"
							:dropdown-options="store.getters.talhoes"
							:ignore-properties="['id', 'Nome']"
						/>
						<DropdownCheckboxFk
							v-model="modelParcela"
							class="w-[400px]"
							:label="$t('plot')"
							:dropdown-options="store.getters.parcelas"
							:ignore-properties="['id', 'Nome']"
						/>
					</div>
				</div>
				<OutlierChart />
			</div>

			<div class="flex justify-end">
				<Button
					:disabled="!ableToContinue"
					:loading="loading"
					class="w-fit"
					width-auto
					:label="$t('finish')"
					@click="createBase"
				/>
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router/composables'
import i18n from '../../../VueI18n'
import BreadCrumb from '../../../components/BreadCrumb/BreadCrumb.vue'
import Button from '../../../components/Button/Button.vue'
import Dropdown from '../../../components/Dropdown/Dropdown.vue'
import DropdownCheckboxFk from '../../../components/DropdownCheckboxFk/DropdownCheckboxFk.vue'
import {
	createBaseHistorica,
	getMedicoesHistoricasByBaseHistoricaId,
} from '../../../services/requests/DadosHistoricosRequests.js'
import { useDadosHistoricosStore } from '../../../store/modules/moduleDadosHistoricos.js'
import { useMessagesStore } from '../../../store/modules/moduleMessages.js'
import OutlierChart from './OutlierChart.vue'

const store = useDadosHistoricosStore()
const messagesStore = useMessagesStore()

const router = useRouter()

const loading = ref(false)

const steps = ref([
	{ name: i18n.t('cadastrarBaseHistorica'), step: 0 },
	{ name: i18n.t('mapeamentoDeColunas'), step: 1 },
	{ name: i18n.t('visualizeDispersion'), step: 2 },
])

const step = ref(2)

const ableToContinue = computed(() => {
	return (
		!store.getters.OBRIGATORIOS_PROCESSAMENTO &&
		!store.getters.OBRIGATORIOS_NAO_MAPEADOS.length &&
		!store.getters.SEM_ESPECIE.length &&
		!store.getters.SEM_MATERIAL_GENETICO.length &&
		!store.getters.SIGLA_INVENTARIO.length &&
		!store.getters.HDOM_MENOR_HMED.length &&
		!store.getters.DG_MENOR_DAP_MED.length &&
		!store.getters.HT_INCONSISTENTE.length &&
		!store.getters.DAP_INCONSISTENTE.length &&
		!store.getters.VICC_MENOR_VISC.length &&
		!store.getters.VTCC_MENOR_VTSC.length &&
		!store.getters.linhasInconsistentes.length
	)
})

const variavelBiometrica = computed({
	get: () => {
		return store.state.variavelBiometrica
	},
	set: (value) => {
		store.commit('setVariavelBiometrica', value)
	},
})

const modelFazenda = computed({
	get() {
		return store.state.fazendasSelecionadas
	},
	set(value) {
		store.commit('changeFazendasSelecionadas', value)
	},
})

const modelTalhao = computed({
	get() {
		return store.state.talhoesSelecionados
	},
	set(value) {
		store.commit('changeTalhoesSelecionados', value)
	},
})

const modelParcela = computed({
	get() {
		return store.state.parcelasSelecionadas
	},
	set(value) {
		store.commit('changeParcelasSelecionadas', value)
	},
})

const medicaoId = computed(() => {
	return window.location.search.split('=')[1]
})

function createBase() {
	loading.value = false

	// Exibe a mensagem de aviso
	messagesStore.commit('mutationShowMessage', {
		messageTitle: i18n.t('aviso'),
		messageText: i18n.t('importingHistoricalBase'),
		messageType: 'warning',
	})

	// Redireciona para a rota desejada
	router.push({ name: 'baseHistorica' })

	// Inicia a requisição em segundo plano
	createBaseHistorica(store.getters.createBaseHistoricaBody)

	// Recarrega a página após pequena pausa para garantir que a mensagem seja exibida
	setTimeout(() => {
		window.location.reload()
	}, 5000)
}

onMounted(async () => {
	console.log(medicaoId.value)

	if (medicaoId.value) {
		getMedicoesHistoricasByBaseHistoricaId(medicaoId.value).then(({ data }) => {
			store.dispatch('handleMedicoesHistoricas', data)
		})

		store.commit('setVariavelBiometrica', store.getters.dropdownVisualizarDispersao[0].value)
	}
})
</script>

<style></style>
